export default function (immutableData) {
  const values = immutableData.toJS();
  const errors = {};

  if (values.codeWord !== values.codeWordConfirm) {
    errors.codeWordConfirm = 'Значения полей должны совпадать';
  }

  return errors;
}
